import { useQuery } from 'react-query'
import PropTypes from 'prop-types'
import { restClient } from 'config/restClient'

const getCurrentUser = async () => {
  const response = await restClient('/api/current_user', {
    method: 'GET',
  })

  return response.data
}

const LoadCurrentUser = ({ children }) => {
  const { data: currentUser = {} } = useQuery(
    ['currentUser'],
    () => getCurrentUser(),
    {
      refetchOnWindowFocus: false,
      select: data => (data || {}),
    },
  )

  return children(currentUser)
}

LoadCurrentUser.propTypes = {
  children: PropTypes.func,
}

export default LoadCurrentUser
